import type { IPublicUser } from '@sravni/types/lib/auth';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type IState = {
  loggedIn: boolean;
  account?: IPublicUser;
  fp: string;
};

const initialState: IState = {
  loggedIn: false,
  fp: '-1',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<IPublicUser>) => {
      state.loggedIn = true;
      state.account = payload;
    },
    destroyUser: () => initialState,
    setFingerprint: (state, { payload }: PayloadAction<string>) => {
      state.fp = payload;
    },
  },
});

const { actions, reducer } = userSlice;

export const { setUser, destroyUser, setFingerprint } = actions;

export default reducer;
